module.exports = __webpack_public_path__ + "static/media/iphone-features-img.9416c2bb.svg";